export class Section {
	id: number;
  number: number;
  description: string;
  departmentId: number;
}
